import * as React from 'react'

import { cn } from '@ps/ds/lib/utils'
import type { LucideIcon } from 'lucide-react'

export const withProgressIconStyles = (Icon: LucideIcon, className: string): LucideIcon => {
  const ProgressIcon = React.forwardRef<SVGSVGElement, React.ComponentProps<LucideIcon>>(
    ({ className: inheritedClassName, ...props }, ref) => {
      return React.createElement(Icon, {
        ...props,
        ref,
        className: cn(inheritedClassName, className),
      })
    },
  )

  ProgressIcon.displayName = 'ProgressIcon'
  return ProgressIcon
}
